// src/index.js - CONFIGURACIÓN TOTAL SCARVACI 2026 CORREGIDA
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import App from './App';
import './index.css';

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: 'us-east-1_eiunAGn9Y',
            userPoolClientId: '46o02ecd6ifalpu95mr0r7ga42',
            identityPoolId: 'us-east-1:7aac591a-1c96-4348-9d2c-7b85a59d619b',
            allowGuestAccess: true,
            loginWith: { email: true }
        }
    },
    API: {
        GraphQL: {
            endpoint: 'https://u25kpi7ppvc7hc2d6m4llybpzy.appsync-api.us-east-1.amazonaws.com/graphql',
            region: 'us-east-1',
            defaultAuthMode: 'userPool', 
            apiKey: 'da2-m6hg5f6u6nbz5gvli7wtfquxmu' 
        },
        REST: {
            AdminQueries: {
                endpoint: 'https://7yv1gbjb82.execute-api.us-east-1.amazonaws.com/staging',
                region: 'us-east-1'
            }
        }
    },
    Storage: {
        S3: {
            bucket: 'gioscarvaciwebf261721cf55f41d593f70878f40bf914c744d-staging',
            region: 'us-east-1'
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);